import React, { useContext, useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby";
import styled from "styled-components";

import { generate as genId } from "shortid";

import { WrapPageContext } from "./ContextWrapper";
import MainNav from "./MainNav";
import TOC from "@components/TOC";

const PageWrapper = styled.div`
	a {
		color: #006adb;
		font-weight: 600;
	}

	a:focus {
		text-decoration: underline;
	}

	width: 100%;
`;

const ContentWrapper = styled.div`
	margin: 0;
	padding: 0;
	padding: 0 1.2em 0 0;
	min-height: 1300px;
	overflow-x: hidden;

	h1 {
		text-align: center;
		margin: 1.4em 0 0.8em 0;
		border-bottom: 1px solid #ccc;
		padding: 0 0 0.4em 0;
	}

	h2 {
		text-align: center;
		margin: 1em 0 1.2em 0;
	}

	h3 {
		margin: 1em 0 1.2em 0;
	}

	p {
		font-size: 1.2em;
	}
`;

const TOCWrapper = styled.div`
	z-index: 90001;
	min-height: 100%;
	width: ${({ mobileWidth }) => mobileWidth};

	@media (min-width: 1200px) {
		width: ${({ width }) => width};
	}
`;

const Layout = ({ children, location, rewriteNavPaths }) => {
	const { site, header, footer, siteConfigJson } = useStaticQuery(graphql`
		{
			site {
				siteMetadata {
					title
					description
				}
			}
			header {
				html
			}
			footer {
				html
			}
			siteConfigJson {
				nav {
					items {
						displayText
						url
					}
				}
			}
		}
	`);

	const { isTocVisible, setIsTocVisible, headingNodes } = useContext(
		WrapPageContext
	);

	const navItems = siteConfigJson.nav.items.map(item => ({
		id: genId(),
		url: rewriteNavPaths ? rewriteNavPaths(item.url) : item.url,
		displayText: item.displayText,
	}));

	const currentNavItem = navItems.find(
		item => item.url === location.pathname
	);

	const TOCHeader = currentNavItem ? currentNavItem.displayText : null;

	useEffect(() => {
		const focusEl = document.getElementById(location.hash);
		if (focusEl && focusEl.tabIndex) {
			focusEl.focus();
		}
	}, [location.hash]);

	return (
		<div>
			<div dangerouslySetInnerHTML={{ __html: header.html }}></div>
			<PageWrapper>
				<MainNav
					menuItems={navItems}
					siteTitle={site.siteMetadata.title}
					location={location}
				/>
				<div className="d-flex h-100">
					<TOCWrapper
						className="m-0 p-0"
						width={isTocVisible ? "360px" : "40px"}
						mobileWidth="20px"
					>
						<TOC
							onToggling={setIsTocVisible}
							expandedWidth="300px"
							collapsedWidth="32px"
							pageName={TOCHeader}
							isVisible={isTocVisible}
							location={location}
							headingNodes={headingNodes}
							shouldDefaultToExpand={false}
						/>
					</TOCWrapper>
					<div className="container-fluid m-0 p-0">
						<ContentWrapper>
							<main>{children}</main>
						</ContentWrapper>
					</div>
				</div>
			</PageWrapper>
			<footer dangerouslySetInnerHTML={{ __html: footer.html }}></footer>
		</div>
	);
};

export default Layout;
